import * as React from 'react';

interface IProps {
    children: any;
}

export const FlyoutFooter = (props : IProps) => {

    return <div className="flyout-footer">
            { props.children }
        </div>;
};
